import { Injectable } from '@angular/core'
import { Apollo } from 'apollo-angular'
import { ApolloQueryResult, gql } from '@apollo/client/core'
import { map } from 'rxjs/operators'

export type OnfidoStatus = 'no_check_started' | 'awaiting_result' | 'rejected' | 'clear'

@Injectable()
export class IdentityService {
    constructor(private apollo: Apollo) {}

    async getOnfidoToken(): Promise<string> {
        const {
            data: {
                getOnfidoSDKToken: { token },
            },
        } = <any>await this.apollo
            .query({
                query: gql`
                    query {
                        getOnfidoSDKToken {
                            token
                        }
                    }
                `,
                variables: {},
            })
            .toPromise()

        return token
    }

    async executeLicenseCheck() {
        await this.apollo
            .mutate({
                mutation: gql`
                    mutation {
                        executeLicenseCheck {
                            result
                        }
                    }
                `,
                variables: {},
            })
            .toPromise()
        return true
    }

    async getStatus(): Promise<OnfidoStatus> {
        let normalizedStatus: OnfidoStatus = 'no_check_started'

        try {
            const status = await this.apollo
                .query({
                    query: gql`
                        query {
                            getIdCheckStatus {
                                result
                            }
                        }
                    `,
                    variables: {},
                })
                .pipe(
                    map(
                        ({ data: { getIdCheckStatus } }: ApolloQueryResult<{ getIdCheckStatus: any }>) =>
                            getIdCheckStatus
                    )
                )
                .toPromise()

            if (status.result) {
                const result = status.result.toString().toLowerCase()

                if (result === 'clear') {
                    normalizedStatus = 'clear'
                } else if (result === 'consider') {
                    normalizedStatus = 'rejected'
                } else if (result === 'awaiting_result') {
                    normalizedStatus = 'awaiting_result'
                } else if (result === 'no_check_started') {
                    normalizedStatus = 'no_check_started'
                }
            }
        } catch (error) {}

        return normalizedStatus
    }
}
